/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ReferencedRulesetDto { 
    id?: string;
    name?: string;
    kind?: ReferencedRulesetDto.KindEnum;
    ownerProjectId?: number;
    ownerProjectName?: string;
    shareable?: boolean;
    linkedProjectIds?: Array<number>;
}
export namespace ReferencedRulesetDto {
    export type KindEnum = 'KI' | 'IDS' | 'HYBRID' | 'CROSS';
    export const KindEnum = {
        KI: 'KI' as KindEnum,
        IDS: 'IDS' as KindEnum,
        HYBRID: 'HYBRID' as KindEnum,
        CROSS: 'CROSS' as KindEnum
    };
}